<template>
  <v-card flat>
    <v-row dense>
      <v-spacer />
      <v-btn icon small :disabled="disableControls" @click="previous">
        <v-icon small>mdi-rewind</v-icon>
      </v-btn>
      <v-btn v-if="!update" icon small :disabled="disableControls" @click="play">
        <v-icon small>mdi-play</v-icon>
      </v-btn>
      <v-btn v-else icon small :disabled="disableControls" @click="pause">
        <v-icon small>mdi-pause</v-icon>
      </v-btn>
      <v-btn icon small :disabled="disableControls" @click="next">
        <v-icon small>mdi-fast-forward</v-icon>
      </v-btn>
      <v-btn icon small :disabled="disableControls" @click="stop">
        <v-icon small>mdi-stop</v-icon>
      </v-btn>
    </v-row>
    <Plotly :data="chartData" :layout="chartLayout"></Plotly>
  </v-card>
</template>

<script>
export default {
  name: "ChartStream",
  components: {
    Plotly: () => import("@/components/charts/Plotly.vue"),
  },
  mixins: [],
  props: {
    data: { type: Array, required: false, default: () => [] },
  },
  data() {
    return {
      update: null,
      currentBatch: 0,
    };
  },
  computed: {
    disableControls() {
      return false;
    },
    chartData() {
      return this.data.length ? this.data[this.currentBatch].data : [];
    },
    chartLayout() {
      return this.data.length ? this.data[this.currentBatch].layout : {};
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    clearTimeout(this.update);
  },
  destroyed() {},
  methods: {
    next() {
      if (this.currentBatch === this.data.length) {
        this.currentBatch = 0;
      } else {
        this.currentBatch += 1;
      }
    },
    previous() {
      if (this.currentBatch === 0) {
        this.currentBatch = this.data.length;
      } else {
        this.currentBatch -= 1;
      }
    },
    stop() {
      this.pause();
      this.currentBatch = 0;
    },
    pause() {
      clearTimeout(this.update);
      this.update = null;
    },
    play() {
      this.next();
      this.update = setTimeout(this.play, 1 * 1000);
    },
  },
};
</script>

<style></style>
